<nav class="nav">
  @if (isUtilityNavBarEnable) {
    <navigation data-test-id="utilityNavigationBar"></navigation>
  } @else {
    <div class="container u-flex u-alignCenter">
      <a
        class="nav__logo"
        data-test-id="NavigationLogo"
        tabindex="0"
        aria-label="'navigate to ' + config?.logoRoute"
        [routerLink]="config?.logoRoute"
      >
      </a>

      @if (showSubNav) {
        <div class="EnrollmentSubHeader">
          @if (showAppID && appID) {
            <p
              class="t-data t-bold EnrollmentSubHeader__Text"
              [innerHTML]="'Application #' + appID"
              data-test-id="workflowSubNavWithhAppId"
            ></p>
          } @else if (enrollmentSubheader && enrollmentSubheader.enable) {
            <p
              class="t-data t-bold EnrollmentSubHeader"
              [innerHTML]="enrollmentSubheader?.content"
              data-test-id="workflowSubNavHeader"
            ></p>
          }
        </div>
      }

      <div class="u-fillRemaining u-flex u-alignCenter u-justifyEnd u-maxY">
        <a class="enrollment__exit" (click)="exitEnrollment()">
          <icon
            [config]="exitIconConfig"
            name="exit"
            data-test-id="workflowNavExitIcon"
          ></icon>
          <p
            class="t-data t-bold"
            [innerHTML]="config?.exitEnrollmentText"
            data-test-id="workflowNavExitEnrollmentText"
          ></p>
        </a>
      </div>
    </div>
  }
</nav>
